<script setup lang="ts">
    import SettingsSubNavigation from '../components/navigation/SettingsSubNavigation.vue';
    import SubNavigation from '../components/navigation/SubNavigation.vue';
</script>
<template>
    <SubNavigation>
        <template #subnavigation>
            <SettingsSubNavigation />
        </template>

        <RouterView />
    </SubNavigation>
</template>
